var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCertification04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 208 100",
    style: {
      enableBackground: "new 0 0 208 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D6212A;}\n\t.st1{fill:#1C427B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "208,0 208,30.2 197.2,35.2 180.4,15.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "208,52.4 208,80.3 172.5,100 142.8,64.9 112.4,80.7 95.9,62.8 95.9,35.2 111.6,53.8 143.5,37.3  171.8,71.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.2,72.9 47,39.5 16,55.2 -0.4,36.7 0.4,36 16.2,54 47.3,38.2 76.4,71.7 111.4,53.4 111.9,54.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.2,76.8 47,43.4 16,59.1 -0.4,40.6 0.4,39.9 16.2,57.9 47.3,42.1 76.4,75.6 111.4,57.3 111.9,58.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.2,80.7 47,47.3 16,63 -0.4,44.5 0.4,43.8 16.2,61.8 47.3,46 76.4,79.4 111.4,61.1 111.9,62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.2,84.6 47,51.2 16,66.9 -0.4,48.4 0.4,47.7 16.2,65.7 47.3,49.9 76.4,83.3 111.4,65 111.9,65.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.2,88.5 47,55 16,70.8 -0.4,52.3 0.4,51.6 16.2,69.6 47.3,53.8 76.4,87.2 111.4,68.9 111.9,69.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.2,92.4 47,58.9 16,74.7 -0.4,56.1 0.4,55.5 16.2,73.5 47.3,57.7 76.4,91.1 111.4,72.8 111.9,73.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.2,96.3 47,62.8 16,78.6 -0.4,60 0.4,59.4 16.2,77.3 47.3,61.6 76.4,95 111.4,76.7 111.9,77.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.2,100.1 47,66.7 16,82.5 -0.4,63.9 0.4,63.3 16.2,81.2 47.3,65.5 76.4,98.9 111.4,80.6 111.9,81.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.2,
    y: 8.7,
    transform: "matrix(0.8801 -0.4747 0.4747 0.8801 7.1784 46.8864)",
    className: "st1",
    width: 34.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.3,
    y: 11.8,
    transform: "matrix(0.8801 -0.4747 0.4747 0.8801 5.8604 47.7372)",
    className: "st1",
    width: 32.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.4,
    y: 14.7,
    transform: "matrix(0.8801 -0.4747 0.4747 0.8801 4.6059 48.5473)",
    className: "st1",
    width: 30,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.6,
    y: 17.7,
    transform: "matrix(0.8801 -0.4747 0.4747 0.8801 3.2914 49.3961)",
    className: "st1",
    width: 27.7,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 21,
    transform: "matrix(0.8801 -0.4747 0.4747 0.8801 1.85 50.3267)",
    className: "st1",
    width: 25.1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 23.9,
    transform: "matrix(0.8749 -0.4843 0.4843 0.8749 0.8837 52.2688)",
    className: "st1",
    width: 22.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.7,
    y: 27.4,
    transform: "matrix(0.8801 -0.4747 0.4747 0.8801 -0.9406 52.1285)",
    className: "st1",
    width: 20.2,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.8,
    y: 30.3,
    transform: "matrix(0.8759 -0.4824 0.4824 0.8759 -2.0101 53.8817)",
    className: "st1",
    width: 18,
    height: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertification04);
export default __webpack_public_path__ + "static/media/icon-certification-04.1b9d16ee1fc9f58382feecc3763f5231.svg";
export { ForwardRef as ReactComponent };